import clsx from 'clsx';

import { colors } from '@/constants/constant';

type TUserAvatarProps = {
  user: string;
  className?: string;
  isTooltip?: boolean;
  isSquare?: boolean;
};
type TAvatarItem = {
  id?: string | number;
  name: string;
  image?: string | null;
};

type TAvatarGroupListProps = {
  list?: TAvatarItem[];
  maxVisible?: number;
  size?: number; // avatar size in px
  className?: string;
  avatarClassName?: string;
  isSquare?: boolean;
};

export const UserAvatarList = ({
  user = '',
  className,
  isTooltip,
  isSquare,
}: TUserAvatarProps) => {
  const initials = user
    ?.trim()
    ?.split(' ')
    ?.slice(0, 2)
    ?.map((word) => word?.charAt(0)?.toUpperCase())
    ?.join('');

  const hash =
    (user && [...user]?.reduce((acc, char) => acc + char?.charCodeAt(0), 0)) ||
    0;
  const bgColor = colors[hash % colors.length];

  return (
    <div
      className={clsx(
        'w-7 h-7 flex items-center justify-center rounded-full text-white font-bold text-sm shadow-md min-w-7 m-0.5',
        isSquare ? 'rounded-md' : 'rounded-full',
        bgColor,
        className
      )}
      title={isTooltip ? user : undefined}
    >
      {initials}
    </div>
  );
};

export const AvatarGroupList = ({
  list = [],
  isSquare = false,
  maxVisible = 5,
  size,
  className,
  avatarClassName,
}: TAvatarGroupListProps) => {
  if (!list || list.length === 0)
    return <span className="text-gray-400">-</span>;

  const visibleItems = list.slice(0, maxVisible);
  const remainingCount = list.length - maxVisible;

  return (
    <div className={clsx('flex items-center -space-x-2', className)}>
      {visibleItems.map((item, index) => (
        <div
          key={item.id ?? index}
          className="relative shrink-0"
          style={{
            width: size,
            height: size,
            // zIndex: maxVisible - index,
            minWidth: size,
          }}
          title={item.name}
        >
          {item.image ? (
            <img
              src={item.image}
              alt={item.name}
              className={clsx(
                'border-2 border-white object-cover w-full h-full',
                isSquare ? 'rounded-md' : 'rounded-full'
              )}
            />
          ) : (
            <UserAvatarList
              user={item.name}
              isTooltip
              className={avatarClassName}
              isSquare={isSquare}
            />
          )}
        </div>
      ))}

      {remainingCount > 0 && (
        <div
          className={clsx(
            'z-20 bg-gray-200 flex items-center justify-center text-[12px] font-semibold text-neutral-primary',
            isSquare ? 'rounded-md' : 'rounded-full'
          )}
          style={{ width: size, height: size, minWidth: size }}
          title={list
            .slice(maxVisible)
            .map((i) => i?.name)
            .join(', ')}
        >
          +{remainingCount}
        </div>
      )}
    </div>
  );
};
